import { _ as _typeof } from '../typeof-D-UKOauR.js';
import { _ as _defineProperty } from '../defineProperty-DmV7cVMj.js';
import { _ as _slicedToArray } from '../slicedToArray-DvtHmgP0.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable */
// @ts-nocheck

function mergeStyles() {
  for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
    objects[_key] = arguments[_key];
  }
  return objects.reduce(function (_final, object) {
    Object.entries(object).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      _final[key] = _objectSpread(_objectSpread({}, _final[key] || {}), value);
    });
    return _final;
  }, {});
}
function deepMergeStyles() {
  var isObject = function isObject(obj) {
    return obj && _typeof(obj) === 'object';
  };
  function deepMergeInner(target, source) {
    Object.keys(source).forEach(function (key) {
      var targetValue = target[key];
      var sourceValue = source[key];
      if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
        target[key] = targetValue.concat(sourceValue);
      } else if (isObject(targetValue) && isObject(sourceValue)) {
        target[key] = deepMergeInner(Object.assign({}, targetValue), sourceValue);
      } else {
        target[key] = sourceValue;
      }
    });
    return target;
  }
  for (var _len2 = arguments.length, objects = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    objects[_key2] = arguments[_key2];
  }
  if (objects.length < 2) {
    throw new Error('DeepMerge: this function expects at least 2 objects to be provided');
  }
  if (objects.some(function (object) {
    return !isObject(object);
  })) {
    throw new Error('DeepMerge: all values should be of type "object"');
  }
  var target = objects.shift();
  var source;
  while (source = objects.shift()) {
    deepMergeInner(target, source);
  }
  return target;
}

// Todo fit Interface for undeling
var mediaQuery = function mediaQuery(breakPoint) {
  return "@media screen and (max-width: ".concat(breakPoint, "px)");
};

// Todo fit Interface for undeling
var mediaQueryOld = function mediaQueryOld(breakPoint) {
  return "@media screen and (min-width: ".concat(breakPoint, "px)");
};
var canHover = function canHover() {
  var isHover = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return "@media (hover: ".concat(isHover ? 'hover' : 'none', ")");
};
var isLeftToRight = function isLeftToRight() {
  var isLeft = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return "[dir=".concat(isLeft ? 'ltr' : 'rtl', "] & ");
};
var ignoreRTL = function ignoreRTL() {
  return '[dir] & ';
};
var placeHolders = function placeHolders(color) {
  return {
    '&::-webkit-input-placeholder': {
      color: color
    },
    '&:-ms-input-placeholder': {
      color: color
    },
    '&::placeholder': {
      color: color
    }
  };
};
var placeHolderShown = function placeHolderShown(color) {
  return {
    '&:placeholder-shown': {
      color: color
    }
  };
};
var supports = function supports(prop, value) {
  return "@supports (".concat(prop, ": ").concat(value, ")");
};
var supportsNot = function supportsNot(prop, value) {
  return "@supports not (".concat(prop, ": ").concat(value, ")");
};
var textOverflowHidden = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
};
var selection = function selection() {
  var backgroundColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'var(--accents-primary-base)';
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'var(--backgrounds-base)';
  return {
    '@global': {
      '::-moz-selection': {
        backgroundColor: backgroundColor,
        color: color
      },
      '::selection': {
        backgroundColor: backgroundColor,
        color: color
      }
    }
  };
};
var inputTypeNumberWithoutArrows = {
  '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
    '-webkit-appearance': 'none'
  },
  '-moz-appearance': 'textfield'
};
var mozScrollbars = function mozScrollbars() {
  var thumbColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'var(--accents-primary-base)';
  var railColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'rgba(0,0,0,0.08)';
  return {
    scrollbarColor: "".concat(thumbColor, " ").concat(railColor),
    scrollbarWidth: 'thin'
  };
};
var ScrollbarCoverage = /*#__PURE__*/function (ScrollbarCoverage) {
  ScrollbarCoverage["Local"] = "&";
  ScrollbarCoverage["Global"] = "";
  return ScrollbarCoverage;
}(ScrollbarCoverage || {});
var scrollbars = function scrollbars() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$coverage = _ref3.coverage,
    coverage = _ref3$coverage === undefined ? ScrollbarCoverage.Local : _ref3$coverage,
    _ref3$width = _ref3.width,
    width = _ref3$width === undefined ? 4 : _ref3$width,
    _ref3$height = _ref3.height,
    height = _ref3$height === undefined ? 4 : _ref3$height,
    _ref3$borderRadius = _ref3.borderRadius,
    borderRadius = _ref3$borderRadius === undefined ? 0 : _ref3$borderRadius,
    _ref3$trackBackground = _ref3.trackBackgroundColor,
    trackBackgroundColor = _ref3$trackBackground === undefined ? 'rgba(0,0,0,0.08)' : _ref3$trackBackground,
    _ref3$trackHoverBackg = _ref3.trackHoverBackgroundColor,
    trackHoverBackgroundColor = _ref3$trackHoverBackg === undefined ? '' : _ref3$trackHoverBackg,
    _ref3$thumbBackground = _ref3.thumbBackgroundColor,
    thumbBackgroundColor = _ref3$thumbBackground === undefined ? 'var(--accents-primary-base)' : _ref3$thumbBackground,
    _ref3$thumbHoverBackg = _ref3.thumbHoverBackgroundColor,
    thumbHoverBackgroundColor = _ref3$thumbHoverBackg === undefined ? 'var(--accents-primary-base-action)' : _ref3$thumbHoverBackg;
  var styles = _defineProperty(_defineProperty(_defineProperty({}, "".concat(coverage, "::-webkit-scrollbar"), {
    width: width,
    height: height
  }), "".concat(coverage, "::-webkit-scrollbar-track"), _defineProperty({
    backgroundColor: trackBackgroundColor
  }, canHover(), {
    '&:hover': {
      backgroundColor: trackHoverBackgroundColor
    }
  })), "".concat(coverage, "::-webkit-scrollbar-thumb"), _defineProperty({
    borderRadius: borderRadius,
    backgroundColor: thumbBackgroundColor
  }, canHover(), {
    '&:hover': {
      backgroundColor: thumbHoverBackgroundColor
    }
  }));
  return styles;
};
var hideScrollbars = {
  scrollbarWidth: 'none',
  '-ms-overflow-style': 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};
var removeAutocompleteBackground = function removeAutocompleteBackground(color) {
  return {
    // eslint-disable-next-line max-len
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus textarea:-webkit-autofill, &:-webkit-autofill:hover textarea:-webkit-autofill:focus, &:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
      boxShadow: "0 0 0 1000px ".concat(color, " inset !important")
    }
  };
};
function isLightMode() {
  return '@media (prefers-color-scheme: light)';
}
function isDarkMode() {
  return '@media (prefers-color-scheme: dark)';
}
function isLandscape() {
  return '@media screen and (orientation: landscape)';
}
function isPortrait() {
  return '@media screen and (orientation: portrait)';
}
function isOS() {
  return '@supports (-webkit-touch-callout: none)';
}

export { ScrollbarCoverage, canHover, deepMergeStyles, hideScrollbars, ignoreRTL, inputTypeNumberWithoutArrows, isDarkMode, isLandscape, isLeftToRight, isLightMode, isOS, isPortrait, mediaQuery, mediaQueryOld, mergeStyles, mozScrollbars, placeHolderShown, placeHolders, removeAutocompleteBackground, scrollbars, selection, supports, supportsNot, textOverflowHidden };
//# sourceMappingURL=index.js.map
